import {
  READ_MICRO_LOAN_NOTIFICATION_ERROR,
  READ_MICRO_LOAN_NOTIFICATION_START,
  READ_MICRO_LOAN_NOTIFICATION_SUCCESS,
} from 'constants/action-types/loanRequests/microLoanNotifications';
import apiAction from 'helpers/apiAction';

export default requestId => dispatch =>
  dispatch(
    apiAction({
      url: `/user/notifications/admin-requests/${requestId}`,
      method: 'PUT',
      API_REQUEST_START: READ_MICRO_LOAN_NOTIFICATION_START,
      API_REQUEST_SUCCESS: READ_MICRO_LOAN_NOTIFICATION_SUCCESS,
      API_REQUEST_FAILURE: READ_MICRO_LOAN_NOTIFICATION_ERROR,
      onEnd: () => false,
    }),
  );
